import React from "react";
import { Box, Typography } from "@mui/material";
import MDButton from "components/MDButton";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";

const GoalOptionCard = ({
    option,
    hoveredCard,
    setHoveredCard,
    handleSubmit,
}) => {
    const isHovered = hoveredCard === option.value;

    return (
        <Box
            onMouseEnter={() => setHoveredCard(option.value)}
            onMouseLeave={() => setHoveredCard(null)}
            sx={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                textAlign: "center",
                borderRadius: 2,
                p: 3,
                boxShadow: isHovered ? 4 : 1,
                border: isHovered
                    ? "2px solid #03A9F4"
                    : "1px solid #e0e0e0",
                transition: "0.3s",
                "&:hover": {
                    cursor: "pointer",
                },
            }}
        >
            {/* Icon and Label */}
            <Grid
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    mb: 2, // consistent margin below label
                }}
            >
                {option.icon}
                <Typography variant="subtitle1" fontWeight="bold" >
                    {option.label}
                </Typography>
            </Grid>

            {/* Description */}
            <Grid sx={{ flexGrow: 1 }}>
                <Tooltip title={option.description} arrow>
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            lineHeight: 1.6,
                            display: "-webkit-box",
                            overflow: "hidden",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: 3,
                            textOverflow: "ellipsis",
                        }}
                    >
                        {option.description}
                    </Typography>
                </Tooltip>
            </Grid>

            {/* Button */}
            <Grid item sx={{ mt: 3 }}>
                <MDButton
                    variant="contained"
                    color="info"
                    fullWidth
                    onClick={() => handleSubmit(option.value)}
                >
                    {option.buttonText}
                </MDButton>
            </Grid>
        </Box>
    );
};

export default GoalOptionCard;
